import AudioComponent from '@/components/audio/index'
import { Howl } from 'howler'

let $vm
const audioPlugin = Vue => {
  const AC = Vue.extend(AudioComponent)

  const audioFn = {
    initAudio({
      src,
      music,
      autoplay = true,
      loop = true,
      volume = 0.5
    }) {
      if (!$vm) {
        $vm = new AC({
          el: document.createElement('div')
        })
        document.body.appendChild($vm.$el)
      }
      if (music && JSON.stringify(music) !== '{}') {
        $vm.music = music
      }
      window.howlAudio = new Howl({
        src,
        autoplay,
        loop,
        volume
      })
      $vm.isPlaying = true
    },
    // 进入游戏后 隐藏播放器
    // 退出游戏后 恢复播放器
    hide() {
      if (!$vm) return false
      $vm.isHide = true
      window.howlAudio && window.howlAudio.pause()
      // 记录当前状态
      $vm.lastStatus = $vm.isPlaying
    },
    show() {
      if (!$vm) return false
      if (!$vm.isHide) return false
      $vm.isHide = false

      if ($vm.lastStatus) {
        window.howlAudio && window.howlAudio.play()
      }

      $vm.lastStatus = null
    }
  }
  Vue.prototype.$audio = audioFn
}

export default audioPlugin